import AccessErrorPage from "./AccessErrorPage";
import { ACCESS_REASON } from "../../utils/accessError";

/**
 * The plain 403 for pages that aren't program content — e.g. a learner opening a composer or admin
 * URL. Rendered in place of the page they asked for, so the URL doesn't change.
 */
const ForbiddenPage = () => (
  <AccessErrorPage
    scope="page"
    error={{ status: 403, code: "FORBIDDEN", reason: ACCESS_REASON.NOT_REGISTERED, registered: false }}
  />
);

export default ForbiddenPage;
